'use client';

import { clsx } from 'clsx';
import { useState } from 'react';

interface ILogoCopyUrlButtonProps {
  path: string;
  copyUrlLabel: string;
  copiedLabel: string;
  copyAriaLabel: string;
}

export function LogoCopyUrlButton({
  path,
  copyUrlLabel,
  copiedLabel,
  copyAriaLabel,
}: ILogoCopyUrlButtonProps): React.JSX.Element {
  const [copied, setCopied] = useState(false);

  const handleClick = async (): Promise<void> => {
    const absoluteUrl = `${window.location.origin}${path}`;
    await navigator.clipboard.writeText(absoluteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={copyAriaLabel}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-full px-4 py-2',
        'border border-transparent shadow-sm ring-1 ring-foreground/10',
        'text-sm font-medium text-foreground transition-colors',
        'hover:bg-muted active:bg-muted',
      )}
    >
      {copied ? copiedLabel : copyUrlLabel}
    </button>
  );
}
